import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import TableRow from "@mui/material/TableRow";
import { SubscriptionTier } from "../../../../../../models";
import { ROUTES } from "../../../../../../history";
import EditIcon from '@mui/icons-material/EditAttributes';
import AppLink from "../../../../../../components/AppLink";
import { reduceString, titleCase, to2DecimalPlaces } from "../../../../../../helpers";
import { blue } from "@mui/material/colors";
import  IconButton  from "@mui/material/IconButton";


const SubscriptionTierListWidget: React.FC<{
  subscriptiontier: SubscriptionTier;
  active?: boolean;
  avatarBgColor?: string;
  onClickCheck?: (p: SubscriptionTier) => void;
}> = ({
  subscriptiontier,
  active = false,
  avatarBgColor = blue[500],
  onClickCheck,
}) => {
  return (
    <TableRow>
      <TableCell component="th" scope="row">
        <Box display="flex" alignItems={"center"}>
          <Box
            display="inline-block"
            sx={{
              mr: 1,
            }}
          >
            <Checkbox
              checked={active}
              onChange={() => {
                if (onClickCheck) {
                  onClickCheck(subscriptiontier);
                }
              }}
            />
          </Box>
          <AppLink
            doNotUseButton
            to={
              ROUTES.ADMIN_BASE + '/settings/app-settings' +
              "/tiers/view/" +
              subscriptiontier.id
            }
          >
            <Typography component="span" fontSize="14px" fontWeight={"bold"}>
              {" "}
              {reduceString(titleCase(subscriptiontier.name) || "Error", 25)}
            </Typography>
          </AppLink>
        </Box>
      </TableCell>
      <TableCell align="right">
        {to2DecimalPlaces(subscriptiontier.price, true)}
      </TableCell>
      <TableCell align="right">{subscriptiontier.maxMembers}</TableCell>
      <TableCell align="right">
        <AppLink          to={
              ROUTES.ADMIN_BASE + '/settings/app-settings' +
              "/tiers/edit/" +
              subscriptiontier.id
            }>
              <IconButton>
                <EditIcon />
              </IconButton>
            </AppLink>
      </TableCell>
    </TableRow>
  );
};

export default SubscriptionTierListWidget;
